export enum HtmlStringFormatterJustifiedBlock {
  Root = 'HtmlStringFormatterJustified',
}
